export const stripHtml = s => s ? s.replace(/<[^>]*>/g, '') : null

export default stripHtml
